/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TransferAgentIntegrationService } from '../../services/wealthlane-award-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../../services/wealthlane-identity-services';

const usePostTransferAgentSetting = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  console.log('id', id);
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          TransferAgentIntegrationService.putApiAwardApiAppTransferAgent(id, payload)
        );
      }
      return await handleRequest(
        TransferAgentIntegrationService.postApiAwardApiAppTransferAgent(payload)
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getTransferAgentSetting');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Transfer Agent Setting ${id != null && id !== '' ? 'edited.' : 'added.'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostTransferAgentSetting;
